function withDebounce(callback: any, delay = 500): typeof callback {
  let timer: any
  return function callWithDebounce(this: any, ...args: Parameters<typeof callback>[]): ReturnType<typeof callback> {
    clearTimeout(timer)
    timer = setTimeout(
      () => {
        callback.call(this, ...args)
      },
      delay
    )
  }
}

export { withDebounce }